import { CommonAPI } from "../Client";

export const getTenantQuoteApi = ({ quoteId, tenantId }) =>
  CommonAPI.get("/tenant/quote", { params: { quoteId, tenantId } });

// Pass the complete quote body, including tenantId, as the payload.
export const updateTenantQuoteApi = (payload) =>
  CommonAPI.put("/tenant/quote", payload, {
    params: { tenantId: payload.tenantId },
  });

export const createTenantQuoteApi = (payload) =>
  CommonAPI.post("/tenant/quote", payload, {
    params: { tenantId: payload.tenantId },
  });

export const deleteTenantQuoteApi = ({ quoteId, tenantId }) =>
  CommonAPI.delete("/tenant/quote", { params: { quoteId, tenantId } });

export const updateTenantQuoteStatusApi = ({
  quoteId,
  tenantId,
  quoteStatus,
  quoteAdminRemarks,
}) =>
  CommonAPI.put("/tenant/quote/status", null, {
    params: { quoteId, tenantId, quoteStatus, quoteAdminRemarks },
  });

export const getTenantQuotesApi = ({
  tenantId,
  page = 0,
  size = 100,
  sortBy = "quoteId",
  quoteId,
  sortDir = "desc",
  search = "",
}) =>
  CommonAPI.get("/tenant/quotes", {
    params: { tenantId, page, size, sortBy, quoteId, sortDir, search: search || undefined },
  });
